export default function Analytics() {
    return <iframe
        title="Показатели МСП"
        className="w-full"
        height={window.innerHeight - (window.innerHeight * 0.1)}
        src="https://app.powerbi.com/view?r=eyJrIjoiN2UzY2RhNGQtOGIzOC00OTZkLWI5NWUtNzAxODJmNzg4MzkwIiwidCI6ImIxMzI2NjIzLThmYTAtNGQ4NS1hNDVmLTBjZmZhNzI0MzBhNyIsImMiOjl9"
        frameBorder="0"
        allowFullScreen="true"
    />
}